export const DEFAULT_PAGE_SIZE = 10;

export function getOffsetLimit(page, limit) {
  limit = Number(limit) || DEFAULT_PAGE_SIZE;
  return {
    offset: (Number(page) - 1) * limit,
    limit,
  };
}

export function getOffset(page, limit) {
  return (Number(page) - 1) * (Number(limit) || DEFAULT_PAGE_SIZE);
}

export function getPageFromOffset(offset, limit) {
  return Math.floor(Number(offset) / Number(limit)) + 1;
}
